import { ListItem, ListItemIcon, ListItemText, Tooltip } from '@material-ui/core';
import { Lock } from '@material-ui/icons';
import TranslatedMessage from '../translations/TranslatedMessage';
import React from 'react';

type LogoutProps = {
  logout: () => void;
}

const Logout: React.FunctionComponent<LogoutProps> = ({ logout }) => {
  return (
    <Tooltip title={<TranslatedMessage id='common.signOut' />}>
      <ListItem button={true} onClick={logout} >
        <ListItemIcon>
          <Lock />
        </ListItemIcon>
        <ListItemText primary={<TranslatedMessage id='common.signOut' />} />
      </ListItem>
    </Tooltip>
  );
}

export default Logout;
